// Prix, places, date, liens et photo se modifient depuis l'espace admin (onglet Réglages).
export const FOUNDER = { name: "Hugo Veller", initials: "HV" };
